import HomeDelivery from './homeDelivery';

export default HomeDelivery;
